import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function Finiture() {
  return (
    <SpecializationPage
      testid="finiture-page"
      quoteService="Finiture e rivestimenti (umidità di risalita)"
      index="/ 09"
      title="Finiture e Rivestimenti"
      lines={["Finiture", "e rivestimenti."]}
      subtitle="I dettagli fanno la differenza. Pavimentazioni, intonaci, tinteggiature e rivestimenti di pregio per dare carattere e valore a ogni ambiente."
      image={IMG.interior}
      accent="Dove la tecnica incontra l'estetica."
      highlight={{
        tag: "Ristrutturazioni chiavi in mano",
        title: "Trattamento dell'umidità di risalita",
        body: [
          "Aloni, efflorescenze saline e intonaci che si sgretolano alla base delle pareti sono i segni tipici dell'umidità di risalita capillare: l'acqua presente nel terreno viene assorbita dalla muratura e risale, trasportando sali che cristallizzano e degradano le superfici.",
          "Interveniamo con un sistema di risanamento a basso spessore: dopo un'analisi della carica salina e del livello di risalita, prepariamo il supporto e applichiamo un ciclo di rasature altamente traspiranti che favoriscono una lenta e continua evaporazione, riportando la parete a un equilibrio stabile senza demolizioni invasive.",
        ],
        steps: [
          { t: "Analisi e preparazione", d: "Misurazione del livello di risalita e della carica salina, rimozione per abrasione degli strati incoerenti fino al supporto sano, senza produrre macerie." },
          { t: "Risanamento traspirante", d: "Applicazione di rasature di risanamento a più strati con rete di armatura, a basso spessore, che agiscono nei capillari della muratura." },
          { t: "Finitura ad alta traspirabilità", d: "Rasatura di finitura e tinteggiatura con prodotti altamente traspiranti (silossanici, silicati, calce) per un risultato duraturo." },
        ],
      }}
      intro={[
        "La fase di finitura è quella che il cliente vive ogni giorno: per questo la curiamo nei minimi dettagli. Selezioniamo materiali di qualità e maestranze specializzate per un risultato impeccabile ed elegante.",
        "Dai pavimenti in gres o parquet agli intonaci decorativi, dalle tinteggiature ai rivestimenti di bagni e cucine, realizziamo finiture su misura coordinate con l'intero progetto di ristrutturazione.",
      ]}
      specs={[
        { k: "Materiali", v: "Di pregio" },
        { k: "Posa", v: "Specializzata" },
        { k: "Stili", v: "Su misura" },
        { k: "Coordinamento", v: "Con il progetto" },
        { k: "Interni ed esterni", v: "Sì" },
        { k: "Finitura", v: "Chiavi in mano" },
      ]}
      benefits={[
        { t: "Estetica curata", d: "Ambienti armoniosi e di carattere, coordinati in ogni dettaglio." },
        { t: "Materiali selezionati", d: "Gres, parquet, resine, pietre e pitture di alta qualità." },
        { t: "Posa a regola d'arte", d: "Maestranze specializzate per risultati precisi e duraturi." },
        { t: "Valore dell'immobile", d: "Finiture di pregio aumentano il valore e l'appetibilità della casa." },
        { t: "Soluzioni su misura", d: "Progettiamo le finiture in base al tuo gusto e al tuo budget." },
        { t: "Tutto coordinato", d: "Integrate nel cantiere chiavi in mano, senza fornitori scollegati." },
      ]}
      applications={[
        "Risanamento umidità di risalita",
        "Pavimenti in gres porcellanato",
        "Parquet e laminati",
        "Pavimenti in resina",
        "Rivestimenti bagno e cucina",
        "Intonaci civili e deumidificanti",
        "Intonaci e stucchi decorativi",
        "Tinteggiature e pitture",
        "Cartongesso e controsoffitti",
        "Nicchie, boiserie e librerie",
        "Rivestimenti in pietra",
        "Microcemento e spatolati",
        "Pavimenti e rivestimenti esterni",
        "Scale e parapetti",
        "Illuminazione d'ambiente e arredo su misura",
        "Porte e serramenti",
      ]}
      faqs={[
        { q: "Cos'è l'umidità di risalita e come si riconosce?", a: "È l'acqua che dal terreno risale per capillarità nelle murature. Si manifesta con aloni, macchie umide alla base delle pareti, distacco di intonaci e pitture ed efflorescenze (depositi biancastri di sali). Se trascurata, indebolisce i supporti e degrada progressivamente le superfici." },
        { q: "Come intervenite sull'umidità di risalita?", a: "Dopo un sopralluogo con misurazione del livello di risalita e della carica salina, prepariamo il supporto rimuovendo per abrasione le parti incoerenti, applichiamo un ciclo di risanamento traspirante a basso spessore con rete di armatura e chiudiamo con finiture e tinteggiature altamente traspiranti. Il sistema favorisce una lenta e continua evaporazione, riportando la parete in equilibrio." },
        { q: "Devo demolire l'intonaco di tutta la stanza?", a: "No. Il ciclo che utilizziamo lavora a basso spessore e per abrasione: si rimuovono solo gli strati ammalorati, senza demolizioni invasive né produzione di macerie. Spesso è possibile intervenire mantenendo la quota originale degli intonaci." },
        { q: "Il trattamento è definitivo?", a: "Il sistema di risanamento agisce nei capillari della muratura e gestisce l'evaporazione dell'acqua nel tempo, mantenendo le superfici sane e prevenendo il ritorno di efflorescenze e degrado. Per garantire la durata usiamo esclusivamente finiture traspiranti (silossaniche, ai silicati o a calce)." },
        { q: "Le finiture sono coordinate con il resto della ristrutturazione?", a: "Sì. Il risanamento dall'umidità e tutte le finiture (pavimenti, rivestimenti, intonaci, tinteggiature) rientrano nel cantiere chiavi in mano: un unico interlocutore coordina materiali, tempi e maestranze per un risultato uniforme." },
        { q: "Quanto tempo serve prima di poter tinteggiare?", a: "Dopo l'applicazione del ciclo di risanamento si attendono le normali stagionature tecniche (fino a circa 28 giorni per la tinteggiatura finale), così da garantire l'asciugatura e la piena traspirabilità del sistema." },
      ]}
    />
  );
}
